import React from 'react';

import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {ListableGroup} from 'search/SearchConstants';

interface Props {
  isActive: boolean;
  isCompact: boolean;
  isExpanded: boolean;
  group: ListableGroup;
  onClick: () => void;
}

export default function GroupSidepanelItem(props: Props): JSX.Element {
  const {isActive, isCompact, group, isExpanded} = props;

  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      isCompact={isCompact}
      onClick={props.onClick}
      parties={[]}
      subTitle={`Count: ${group.count}`}
      title={{text: group.label}}
      isExpandable={true}
      isExpanded={isExpanded}
      isChild={false}
    />
  );
}
